import { useWizard } from "react-use-wizard";
import AimStep from "../../../../../../../shared/wizard/steps/aimStep";
import buySteps from "../../buySteps";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import { EPurchasePurpose } from "../../../../../../../shared/wizard/steps/types";

interface SelectionByOwnSwapStep_10 {
  isNextStepDisabled: boolean;
  onChange: (
    data: EPurchasePurpose,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
  data: EPurchasePurpose | null;
}

const SelectionByOwnSwapStep_10 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
}: SelectionByOwnSwapStep_10) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_9);
    onReset(["aim"]);
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_11);
  };

  return (
    <div>
      <AimStep
        onNexStep={handleNextStep}
        onPrevStep={handlePrevStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
      />
    </div>
  );
};

export default SelectionByOwnSwapStep_10;
